import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { SuperAdminService } from "src/app/super-admin.service";

@Component({
  selector: "app-date-wise-expense",
  templateUrl: "./date-wise-expense.component.html",
  styleUrls: ["./date-wise-expense.component.css"],
})
export class DateWiseExpenseComponent implements OnInit {
  expenseArray: any[] = [];

  month!: number;
  year!: number;
  companyId!: string;
  supervisorId!: string;

  // UI only (optional)
  monthArrFull: string[] = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private toastr: ToastrService,
    private superadminService: SuperAdminService
  ) {
    this.activatedRoute.params.subscribe((param) => {
      this.month = +param.id;
      this.companyId = param.company;
      this.supervisorId = param.supervisor;
      this.year = +param.year;
    });
  }

  ngOnInit(): void {
    this.getExpense();
  }

  getExpense() {
    this.superadminService
      .dateWiseGeneralExpense(
        this.year,
        this.month,
        this.companyId,
        this.supervisorId
      )
      .subscribe(
        (res: { status: boolean; message: string; data: any[] }) => {
          if (res.status) {
            this.expenseArray = res.data || [];
          } else {
            this.toastr.error(res.message);
          }
        },
        () => {
          this.toastr.error("Failed to load expense data");
        }
      );
  }

  get monthName(): string {
    return this.monthArrFull[this.month - 1] || "";
  }

  backTo() {
    window.history.back();
  }
}
